import { activitiesInformationInit } from "../types/activityTasks";

// export const activitiesInformation = localStorage.getItem("saveGame") ? JSON.parse(localStorage.getItem("saveGame")) : activitiesInformationInit;

const checkDifferences = (jsonInformation, supporInformation) => {
	for (const key in jsonInformation) {
		if (Object.hasOwnProperty.call(jsonInformation, key)) {
			let sumCompleteTask = 0
			const elementInit = jsonInformation[key];
			const elementSupport = supporInformation[key];
			//*  title, subtitle, team
			elementInit.title = elementSupport.title;
			elementInit.subtitle = elementSupport.subtitle;
			elementInit.points = elementSupport.points;
			elementInit.nextActivity = elementSupport.nextActivity;

			//* tasks
			const newTasks2 = supporInformation[key].task.map((t, index) => {
				const taskLocal = elementInit.task[index];
				const jsonTaskMerge = {
					...t,
					url: t?.url ?? "/home1/introduction",
					title: t?.title ?? "",
					pointsWon: taskLocal?.pointsWon ?? 0,
					isComplete: taskLocal?.isComplete ?? undefined,
					isOpen: taskLocal?.isOpen ?? false,
				};
				sumCompleteTask += taskLocal?.isComplete ? 1 : 0
				return jsonTaskMerge;
			});
			elementInit.numberOfTask = supporInformation[key].numberOfTask;
			elementInit.numberOfTaskCompleted = sumCompleteTask
			elementInit.task = newTasks2;
		}
	}
	const getObjectLengthLocalStorage = Object.keys(jsonInformation);
	const getObjectLengthSupport = Object.keys(supporInformation);
	if (getObjectLengthLocalStorage.length !== getObjectLengthSupport.length) {
		let newJsonInformation = {
			...supporInformation,
			...jsonInformation,
		}
		return newJsonInformation
	}
	return jsonInformation;
};

export const activitiesInformation = () => {
	let activitiesInformation = activitiesInformationInit;

	if (localStorage.getItem("saveGame")) {
		try {
			const differences = checkDifferences(JSON.parse(localStorage.getItem("saveGame")), activitiesInformationInit);
			activitiesInformation = differences;
		} catch (error) {
			console.log('fallo', error);
			localStorage.clear()
			window.location.reload();

		}
	}

	return activitiesInformation;
};
